"use client"

import { useNavigate } from "react-router-dom"

type Props = {
  artistName?: string
  artistImage?: string
  artistBio?: string
  artistLink?: string
  fallbackImage?: string
}

export default function ArtistCard({
  artistName,
  artistImage,
  artistBio,
  artistLink,
  fallbackImage,
}: Props) {
  const navigate = useNavigate()
  const isFallback = !artistImage
  const image = artistImage || fallbackImage

  return (
    <article
      onClick={() => artistLink && navigate(`/artist/${artistLink}`)}
      className="
        group relative isolate overflow-hidden rounded-2xl
        border-y border-[var(--soft-border)] bg-[var(--soft-bg)]
        cursor-pointer transition-[border-color] duration-200
        hover:border-white/5
      "
    >
      {/* IMAGEN */}
      <div
        className={`
          relative isolate overflow-hidden rounded-[inherit] flex justify-center items-center
          ${isFallback ? "aspect-[16/4]" : "aspect-[16/9]"}
        `}
        style={{ clipPath: "inset(0 round 1rem)" }}
      >
        {image ? (
          <div className="absolute inset-0 overflow-hidden rounded-[inherit]">
            <img
              src={image}
              alt=""
              draggable={false}
              className={`
                absolute h-[calc(100%+40px)] w-[calc(100%+40px)]
                object-cover transform-gpu
                ${isFallback
                  ? "blur-xl contrast-[1.5] brightness-[1.2] opacity-85"
                  : ""
                }
              `}
            />
          </div>
        ) : (
          <div className="absolute inset-0 rounded-[inherit] bg-gradient-to-br from-zinc-800 via-zinc-900 to-black" />
        )}

        {/* GRADIENT */}
        <div className="pointer-events-none absolute inset-0 z-10 rounded-[inherit] bg-gradient-to-b from-black/10 via-black/35 to-black/[.92]" />

        {/* FALLBACK INFO */}
        {isFallback && (
          <div className="absolute inset-x-0 bottom-0 z-20 p-4 sm:p-5">
            <p className="text-[9px] font-semibold uppercase tracking-[.2em] text-white/40">
              Artista
            </p>

            <h3 className="mt-1 truncate text-lg font-semibold tracking-[-.02em] text-white">
              {artistName || "Artista desconocido"}
            </h3>

            {artistBio && (
              <p className="mt-1.5 line-clamp-3 max-w-[38rem] text-xs leading-relaxed text-white/60">
                {artistBio}
              </p>
            )}
          </div>
        )}
      </div>

      {/* INFO */}
      {!isFallback && (
        <div className="px-3.5 py-3">
          <h3 className="truncate text-[13px] font-semibold text-white">
            {artistName}
          </h3>

          {artistBio && (
            <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-white/50">
              {artistBio}
            </p>
          )}
        </div>
      )}
    </article>
  )
}